import type { GlobalNavItemStoryblok } from '@/lib/types/component-types-sb'
import { NavSubMenuColCard } from './nav-sub-menu-col-card'
import { NavSubMenuColCaseStudy } from './nav-sub-menu-col-case-study'
import { NavSubMenuColLatestRelease } from './nav-sub-menu-col-latest-release'
import { NavSubMenuColLinks } from './nav-sub-menu-col-links'

export function NavSubMenu({ item }: { item: GlobalNavItemStoryblok }) {
  return (
    <div className="bg-sidebar border-border rounded border">
      <div className="grid w-[900px] grid-cols-3 gap-2.5 px-5 py-4">
        {item.cols?.map((col) => {
          switch (col.component) {
            case 'global-nav-sub-menu-col-card':
              return (
                <NavSubMenuColCard
                  key={col._uid}
                  col={col}
                />
              )
            case 'global-nav-sub-menu-col-links':
              return (
                <NavSubMenuColLinks
                  key={col._uid}
                  col={col}
                />
              )
            case 'global-nav-sub-menu-col-latest-release':
              return (
                <NavSubMenuColLatestRelease
                  key={col._uid}
                  col={col}
                />
              )
            case 'global-nav-sub-menu-case-study':
              return (
                <NavSubMenuColCaseStudy
                  key={col._uid}
                  col={col}
                />
              )
            default:
              return null
          }
        })}
      </div>
    </div>
  )
}
